import BaseStore from 'customer-flows/stores/base-store'
import { tracked } from '@glimmer/tracking'
import { service } from '@ember/service'

export default class ApplicationStoreClass extends BaseStore {
  @tracked loadingCount = 0
  @tracked partnerKey?: string
  @tracked legacyProgramId?: string
  @tracked regionData?: RegionData

  @service flowRouter: FlowRouter

  get isGdpr(): boolean | undefined {
    return this.regionData?.['is-gdpr']
  }

  get referralUrl(): string | undefined {
    return this.flowRouter.canonicalUrl
  }

  get channelId(): string | undefined {
    const { channelId, channelID } = this.flowRouter.queryParams ?? {}
    return channelId ?? channelID
  }

  get loading(): boolean {
    return this.loadingCount > 0
  }
}

declare global {
  export type ApplicationStore = ApplicationStoreClass
  export interface StoreRegistry {
    application: ApplicationStore
  }
}
